import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../../../../i18n';
import AttendanceIcon from '../../../../../../../../icons/AttendanceIcon';
import TileDrawerHeaderLayout from '../../../../../../../shared/TileDrawerHeaderLayout';

const RecordAttendanceDrawerHeader = () => {
  const { t } = useTranslation([i18nNS.CLASS]);

  return (
    <TileDrawerHeaderLayout icon={AttendanceIcon} color="warning">
      {t('record_attendance', { ns: i18nNS.CLASS })}
    </TileDrawerHeaderLayout>
  );
};

export default RecordAttendanceDrawerHeader;
